import React from "react";
import { MapPin, Navigation, ArrowRight } from "lucide-react";
import { ICON_STROKE } from "../ui/icon";

const NearbyMapPreview = ({ services, mapUrl, onOpenMap }) => {
  const previewServices = services.slice(0, 3);

  return (
    <div className="nearby-map-preview">
      <div className="nearby-map-preview__header">
        <div>
          <p className="nearby-map-preview__eyebrow">Nearest Services</p>
          <p className="nearby-map-preview__title">Map Preview</p>
        </div>
        <button type="button" className="nearby-map-preview__link" onClick={() => onOpenMap(mapUrl)}>
          Open Full Map
          <ArrowRight size={16} strokeWidth={ICON_STROKE} />
        </button>
      </div>
      <div className="nearby-map-preview__canvas">
        <div className="nearby-map-preview__grid" aria-hidden />
        <div className="nearby-map-preview__pins">
          {previewServices.map((svc, idx) => (
            <span
              key={`${svc.name}-${idx}`}
              className="nearby-map-preview__pin"
              style={{
                left: `${20 + idx * 28}%`,
                top: `${35 + (idx % 2) * 18}%`,
              }}
            >
              <MapPin size={16} strokeWidth={ICON_STROKE} />
            </span>
          ))}
          <span className="nearby-map-preview__you">
            <Navigation size={14} strokeWidth={ICON_STROKE} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default NearbyMapPreview;
